/**
 * File: renderUserRoutes.js
 * Origin: isotect
 * Description: Functions that render user routes.
 *
 * Version: v1.0.2
 * Created: 2026-06-21
 * Last Updated: 2026-06-23
 *
 * Used By: isotect
 * Maintainer: Zachary Dicks
 *
 * Notes:
 * - Changes in this file may affect all consuming frontend modules.
 * - See Git repository 'isotect' for full change history.
 */

// Third-party packages
import { Route } from "react-router-dom";

// Local project files
import { AuthLayout } from "../components/layout/RouteLayouts";
import { routes } from "../constants/routes";
import * as schemas from "../schemas/schemas";
import DashboardPage from "../pages/DashboardPage";
import OrderPage from "../pages/OrderPage";

/**
 * Creates the route configuration for authenticated user routes.
 *
 * @param {boolean} isUserAuth - Whether the current user is authenticated
 *
 * @returns {React.ReactElement} A Route element containing user-specific routes
 */
function renderUserRoutes(isUserAuth) {
    return (
        <Route
            path={routes.user.root}
            element={
                <AuthLayout
                    isAuth={isUserAuth}
                    navigateUrl={routes.public.auth.signIn.abs}
                    navigationSchema={schemas.userSideNavigation}
                />
            }
        >
            <Route
                path={routes.user.dashboard.rel}
                element={<DashboardPage />}
            />
            <Route
                path={routes.user.orders.rel}
                element={<OrderPage schema={schemas.orderPage} />}
            />
        </Route>
    );
}

export { renderUserRoutes };
